<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper :routerLink="'/adjustments'" min="1" max="100" v-model="value.blocksize" label="menu.pixelate"/>
  </div>
</template>

<script lang="ts">
import { Adjustments } from '@filestack/canvas-sdk';
import { Component } from 'vue-property-decorator';
import { FilterMixin } from './FilterMixin';

@Component
class Pixelate extends FilterMixin {
  protected value = { blocksize: 1 };

  protected filter = new Adjustments.Pixelate();
}

export default Pixelate;
</script>
